
type ClassObject = {
  [className: string]: boolean | null | undefined;
};

/**
 * Takes any number of args (string, object, etc.) and returns a string of class names.
 * Objects are evaluatedd as key-value pairs where the key is the class name and the value defines
 * whether the class should be included (falsy or not).
 * 
 * @example
 * classNames("class1", "class2", { "class3": true, "class4": false }) // "class1 class2 class3"
 */
export const classNames = (
  ...classes: (string | ClassObject | null | undefined)[]
) => {

  return classes
    .filter((className) => className) // Remove null or undefined
    .map((className) => {
      if (typeof className === "string") {
        return className;
      }

      return Object.entries(className!)
        .filter(([_key, value]) => value) // Remove falsy values
        .map(([key]) => key);
    })
    .flat()
    .join(" ");

};